import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 12/16;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 12 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 1.25C3.77208 1.25 0.750001 4.27208 0.75 8C0.75 11.7279 3.77208 14.75 7.5 14.75" fill="transparent" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M8.47424 5L11.25 8.00001L8.47424 11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.0326 8L3.75 8" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
)

export default class IconLogout extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
